<template>
	<div class="col-12">
		<div class="card card-outline card-info">
			<div class="card-header">
				<h3 class="card-title">Lista de chequeras</h3>
				<div class="card-tools">
					<button v-can="'add_checkbook'" class="btn btn-sm btn-outline-info" @click="addCheckbook()">
						<i class="fa fa-plus"></i> Chequera
					</button>
				</div>
			</div>
			<div class="card-body">
				<div class="row">
					<div class="col-md-3">
						<label>Nombre :</label>
						<input type="text" class="form-control" v-model="search.name" @keyup="list()" />
					</div>
					<div class="col-md-3">
						<label>Empresa :</label>
						<select class="form-control" v-model="search.company_id" @change="list()">
							<option value="">Todos</option>
							<option v-for="(company, index) in catalogue.companies_all" :value="company.id" :key="index">
								{{ company.name }}
							</option>
						</select>
					</div>				
					<div class="col-md-3">
						<label>Banco :</label>
						<select class="form-control" v-model="search.bank_id" @change="list()">
							<option value="">Todos</option>
							<option v-for="(bank, index) in catalogue.banks" :value="bank.id" :key="index">
								{{ bank.name }}
							</option>
						</select>
					</div>
					<div class="col-md-3">
						<label>Estatus :</label>
						<select class="form-control" v-model="search.status" @change="list()">
							<option value="">Todos</option>
							<option value="1">Activo</option>
							<option value="0">Inactivo</option>
						</select>
					</div>
				</div>
				<br>
				<div class="row">
					<div class="col-md-12">
						<ul class="nav nav-tabs" id="custom-tabs-one-tab" role="tablist">
							<li class="nav-item">
								<a class="nav-link active" @click="searchCheckbooks(1)" data-toggle="pill" role="tab"
									aria-selected="true">Vigentes</a>
							</li>
							<li class="nav-item">
								<a class="nav-link" @click="searchCheckbooks(2)" data-toggle="pill" role="tab"
									aria-selected="false">Terminados</a>
							</li>
						</ul>
					</div>
				</div>
				<div class="table-responsive">
					<table class="table table-bordered text-center text-sm">
						<thead>
							<tr>
								<th>ID</th>
								<th>Nombre</th>
								<th>Fecha</th>
								<th>Empresa</th>
								<th>Usuario</th>
								<th>Banco</th>
								<th>Opciones</th>
							</tr>
						</thead>
						<tbody v-if="load">
							<tr>
								<td colspan="6" class="text-center">
							<i class="fa-solid fa-circle-notch fa-spin fa-3x mb-1"></i>
							<h5>Cargando</h5>
							</td>
							</tr>
						</tbody>
						<tbody v-else-if="checkbooks.data.length > 0">
							<tr v-for="(checkbook, index) in checkbooks.data" :key="index">
								<td>
									{{ checkbook.id }}<br>
									<span v-if="checkbook.status == 1" class="badge bg-success">Activo</span>
									<span v-else-if="checkbook.status == 0" class="badge bg-warning">Inactivo</span>									
									<span v-else class="badge bg-danger">Terminados</span>
								</td>
								<td>
									{{ checkbook.name }}
									<hr>
									{{ checkbook.id_ini }} / {{ checkbook.id_end }}
								</td>
								<td>{{ checkbook.date | toDateTime }}</td>
								<td>
									<span v-if="checkbook.company">
										{{ checkbook.company.name }}
									</span>
									<span v-else>Sin Usuario</span>
								</td>
								<td>
									<span v-if="checkbook.user">
										{{ checkbook.user.name }} {{ checkbook.user.last_name }}
									</span>
									<span v-else>Sin Usuario</span>
								</td>
								<td>
									<span v-if="checkbook.bank">
										{{ checkbook.bank.name }}
									</span>
									<span v-else>Sin banco</span>
								</td>								
								<td>
									<button @click="changeStatus(checkbook)" v-can="'edit_checkbook'"
										class="btn m-1 btn-outline-primary btn-sm" :class="checkbook.status != 2 ? 'btn-outline-danger' : 'btn-outline-success'">
										<i class="fa-solid fa-power-off"></i> 
										<span v-if="checkbook.status != 2">
											Terminar
										</span>
										<span v-else>
											Activar
										</span>
									</button>

									<button @click="addCheckbook(checkbook, false)" v-can="'edit_checkbook'"
										class="btn m-1 btn-outline-primary btn-sm">
										<i class="fas fa-eye "> </i> Ver
									</button>
									<button @click="addCheckbook(checkbook)" v-can="'edit_checkbook'" v-if="checkbook.pays_count == 0"
										class="btn m-1 btn-outline-success btn-sm">
										<i class="fas fa-edit "> </i> Editar
									</button>
									<button type="button" @click="deleted(checkbook.id)" v-can="'deleted_checkbook'" v-if="checkbook.pays_count == 0"
										class="btn-outline-danger btn m-1 btn-sm ">
										<i class="fa fa-trash"></i> Eliminar
									</button>
									<button type="button" @click="showFoliosCheckbooks(checkbook)"
										class="btn-outline-info btn m-1 btn-sm ">
										<i class="fa fa-list"></i> Detalles
									</button>
								</td>
							</tr>
						</tbody>
						<tbody v-else>
							<tr>
								<td align="center" colspan="6">Sin resultados.</td>
							</tr>
						</tbody>
					</table>
					<pagination v-model="page" :records="checkbooks.total" :per-page="checkbooks.per_page"
						@paginate="list" />
				</div>
			</div>
		</div>
		<ModalFormComponent :prop_edit="edit" />
		<ModalListFoliosComponent :prop_edit="edit" />
	</div>
</template>

<script>
import { mapMutations, mapActions } from 'vuex';
import Pagination from 'vue-pagination-2';
import request from '@/services/request';
import ModalFormComponent from '@/components/checkbook/ModalFormComponent.vue';
import ModalListFoliosComponent from '@/components/checkbook/ModalListFoliosComponent.vue';
import Catalogue from '@/services/catalogue';

export default {
	name: "checkbook-table",
	components: {
		Pagination,
		ModalFormComponent,
		ModalListFoliosComponent
	},
	data() {
		return {
			catalogue: new Catalogue(),
			checkbooks: [],
			edit: false,
			load: false,
			search: {
				name: '',
				status: '',
				company_id: '',
				bank_id: '',
				deactivate: 1
			},
			page: 1
		}
	},
	mounted() {
		this.catalogue.get_banks();
		this.catalogue.get_companies_all();
		this.list();
		this.setHeaderTitle('chequeras');
	},
	created() {
		Event.$on("event-load-checkbook", () => {
			this.list();
		});
	},
	methods: {
		searchCheckbooks(value) {
			this.search.deactivate = value;
			this.list();
		},
		changeStatus(checkbook) {
			let tit = 'Terminar chequera';
			let txt = 'Seguro que quiere terminar chequera';
			if (checkbook.status == 3) {
				tit = 'Activar chequera';
				txt = 'Seguro que quiere activar la chequera';
			} 
			

			this.$swal({
				title: tit,
				text: txt,
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Ok',
				cancelButtonText: 'Cancelar'
			}).then(async (result) => {
				if (result.isConfirmed) {
					let _endpoint = '/checkbook_status?id=' + checkbook.id;
					try {
						let response = await request.post(_endpoint).then(function (response) { return response; });
						this.list();
						this.successNotification(response.data.message);
					} catch (error) {
						this.errors = await this.errorNotification(error)
					}
				}
			});
		},
		getFoliosCheckbooks(checkbook_id) {
			this.catalogue.getFoliosCheckbooks(checkbook_id);
		},
		showFoliosCheckbooks(checkbook) {
			Event.$emit('event-show-showFoliosCheckbooks', checkbook);
		},
		addCheckbook(checkbook = false, edit = true) {
			this.edit = edit;
			Event.$emit('event-show-addCheckbook', checkbook);
		},
		deleted: function (id) {
			let tit = 'Eliminar chequera';
			let txt = 'Seguro que quiere eliminar la chequera';

			this.$swal({
				title: tit,
				text: txt,
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Ok',
				cancelButtonText: 'Cancelar'
			}).then(async (result) => {
				if (result.isConfirmed) {
					let _endpoint = '/checkbook/' + id;
					try {
						let response = await request.destroy(_endpoint).then(function (response) { return response; });
						this.list();
						this.successNotification(response.data.message);
					} catch (error) {
						this.errors = await this.errorNotification(error)
					}
				}
			});
		},
		async list(page = 1) {
			this.load = true;
			let service = request;
			let search = this.search;
			let _endpoint = '/checkbook';
			try {
				let { data } = await service.list(_endpoint, page, search)
				if (data) {
					console.log(data);
					this.checkbooks = data;
					this.load = false;
				}
			} catch (error) {
				console.log(error);
				this.load = false;
			}
		},
		...mapMutations({
			setHeaderTitle: 'setHeaderTitle',
		}),
		...mapActions({
			resetPassword: 'auth/resetPass',
			errorNotification: 'alert/error',
			successNotification: 'alert/success',
		}),
	}
}
</script>

<style scoped>
.pagination {
	margin-bottom: 0;
}
</style>
